export const JobRelationName = {
  Items: 'items',
  Sor: 'sor',
  Tasks: 'tasks',
  Invoices: 'invoices',
  Bills: 'bills',
  Quotes: 'quotes',
  SaleOrders: 'saleOrders',
  PurchaseOrders: 'purchaseOrders',
} as const;
